import React from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import i18n from "../../i18n.js";

const Person = ({ person }) => {
    const { t } = i18n;

    return (
        <Box>
            <List dense>
                <React.Fragment>
                    <ListItem>
                        <ListItemText primary={`${person.fullName}`} secondary={t("reg.name")} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={t(person.type)} secondary={t("reg.type")} />
                    </ListItem>
                </React.Fragment>
            </List>
        </Box>
    );
};

export default Person;
